import Link from "next/link"
import Image from "next/image"
import { useState } from "react"
import Blocks from "@/components/Blocks"
import styles from "./image-card.module.css"
import { trackProductClick } from "@/lib/helpers/tagManager"
import classNames from "classnames"
import { isLinkTargetBlank } from "@/lib/helpers/linkAttrs"

export default function ImageCard({ block }) {
  const { innerBlocks, attrs } = block
  const settings = {
    "core/heading": { width: "bleed" },
    "core/paragraph": { width: "bleed" },
    "theme/link": {
      width: "bleed",
      noLink: true,
      isButton: true
    }
  }

  if (attrs?.isEmpty) {
    return null
  }

  return (
    <Container {...{ attrs }}>
      <Media
        media={attrs.media}
        image={attrs.image}
        address={attrs.address}
        zoom={attrs.zoom}
      />
      <div className="content-wrapper">
        <Blocks
          tracking={attrs.tracking}
          blocks={innerBlocks}
          settings={settings}
        />
      </div>
    </Container>
  )
}

const Container = ({ attrs, children }) => {
  const trackProduct = () => trackProductClick(attrs?.tracking, "gift")
  const hasLink = attrs?.link?.url && attrs.link.url.length > 0

  const classes = [
    styles.wrapper,
    "card",
    {
      "has-text-button":
        attrs.buttonTheme === "text" && !attrs.hideButton && hasLink,
      "has-button": attrs.buttonTheme !== "text" && !attrs.hideButton && hasLink
    }
  ]

  if (!hasLink) {
    return (
      <div className={classNames(classes)} onClick={trackProduct}>
        {children}
      </div>
    )
  }

  if (isLinkTargetBlank(attrs?.link?.target)) {
    return (
      <a
        className={classNames(classes)}
        href={attrs?.link?.url}
        target="_blank"
        rel="noreferrer"
        onClick={trackProduct}>
        {children}
      </a>
    )
  }

  return (
    <Link
      href={attrs?.link?.url}
      prefetch={false}
      onClick={trackProduct}
      className={classNames(classes)}>
      {children}
    </Link>
  )
}

export function Media({ media, layout, image, address, zoom }) {
  const mapKey = process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY
  const size = layout === "fourth" ? "720x720" : "720x540"
  const [state, setState] = useState("loading")

  const query =
    new URLSearchParams({
      key: mapKey,
      zoom: zoom,
      scale: 2,
      size: size,
      markers: address
    }).toString() + "&style=feature:water|geometry.fill|color:0xa0b5d5"

  const mapSrc =
    media === "map" && address.length > 0
      ? "https://maps.googleapis.com/maps/api/staticmap?" + query
      : null

  if (media === "image" && !image) {
    return null
  }

  if (media === "map" && !mapSrc) {
    return null
  }

  return (
    <div
      className={classNames([
        "media-wrapper",
        state,
        { fourth: layout === "fourth" }
      ])}>
      <figure>
        {media === "image" && (
          <Image
            className={styles.image}
            onLoad={() => setState(false)}
            alt={image.alt}
            src={image.url}
            width={image.width}
            height={image.height}
            sizes={image.sizes}
          />
        )}
        {media === "map" && (
          <img
            className={styles.map}
            alt={"Karta till " + address}
            src={mapSrc}
          />
        )}
      </figure>
    </div>
  )
}
